




















































import Vue from 'vue';
import axios, { AxiosResponse } from 'axios';
//const config = require('config');
const config = require('../config/default.json');
const randomstring = require('randomstring');

//定数
const prod = 1;
const sta = 2;
const dev = 3;

const all = 1;
const refreshAccessTokenThenFetchCard = 2;
const registerEmployeeAndDeleteIt = 3;
const createAlligateAdmissionCard = 4;
const issueCercardThenProofAndVerify = 5;
const loginCustomerPortalThenShowList = 6;
const getProofAndVerify = 7;

const timeout_durable_function_msec = 15 * 60 * 1000;

//  durable function API 実行結果
class CheckStatusResult {
    id: string = '';
    statusQueryGetUri: string = '';
    sendEventPostUri: string = '';
    terminatePostUri: string = '';
    rewindPostUri: string = '';
    purgeHistoryDeleteUri: string = '';
}

// status API　実行結果
class StatusQueryGetUriResult {
    name: string = '';
    instanceId: string = '';
    runtimeStatus: string = '';
    input: any = {};
    customStatus: any = null;
    output: any = {};
    createdTime: string = '';
    lastUpdatedTime: string = '';
}

class ServiceStatus {
    service: string = '';
}

// ビューモデル
export default Vue.extend({
    data() {
        return {
            results: {
                refreshAccessTokenThenFetchCard: {
                    service: '未確認',
                },
                registerEmployeeAndDeleteIt: {
                    service: '未確認',
                },
                createAlligateAdmissionCard: {
                    service: '未確認',
                },
                issueCercardThenProofAndVerify: {
                    service: '未確認',
                },
                loginCustomerPortalThenShowList: {
                    service: '未確認',
                },
                getProofAndVerify: {
                    service: '未確認',
                },
            },
            smartmeEnv: prod,
            scenario: all,
            isProcessing: false,
            // alert
            message: {
                availability: '',
                alertType: 'info',
                alertDescription: '',
            },
            radioDisabled: {
                prod: true,
                sta: true,
                dev: true
            },
            envTitle : "商用"
        };
    },
    methods: {
        // Log the user in
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
        getEnvString(env: number) {
            if (env === 1) {
                return 'prod';
            } else if (env === 2) {
                return 'sta';
            } else if (env === 3) {
                return 'dev';
            } else {
                return 'other';
            }
        },
        getScenarioString(scenario: number) {
            if (scenario === 1) {
                return 'all';
            } else if (scenario === 2) {
                return 'refreshAccessTokenThenFetchCard';
            } else if (scenario === 3) {
                return 'registerEmployeeAndDeleteIt';
            } else if (scenario === 4) {
                return 'createAlligateAdmissionCard';
            } else if (scenario === 5) {
                return 'issueCercardThenProofAndVerify';
            } else if (scenario === 6) {
                return 'loginCustomerPortalThenShowList';
            } else if (scenario === 7) {
                return 'getProofAndVerify';
            }
        },
        async initializeStatus(): Promise<any> {
            this.Availability = '';
            this.results[refreshAccessTokenThenFetchCard].service = '未確認';
            this.results[registerEmployeeAndDeleteIt].service = '未確認';
            this.results[createAlligateAdmissionCard].service = '未確認';
            this.results[issueCercardThenProofAndVerify].service = '未確認';
            this.results[loginCustomerPortalThenShowList].service = '未確認';
            this.results[getProofAndVerify].service = '未確認';
        },

        async toWIP(scenario) {
            this.results[scenario].service = 'checking';
        },
        async executeTest(env, scenario) {
            this.toWIP(scenario);
            if (scenario === 'createAlligateAdmissionCard') {
                // Alligateの試験がうまく動かないので一時的にダミーとする。
                this.results[scenario] = await this.dummyAlligateTest(200);
            } else {
                const url = this.getEndpoint(env, scenario);
                console.log(`url: ${url}`);
                this.results[scenario] = await this.healthCheckDurableFunction(url);
            }
            console.log(`this.result: ${JSON.stringify(this.results[scenario])}`);
        },
        async dummyAlligateTest(sleeptime) {
            const _sleep = (sec: number) => new Promise((resolve) => setTimeout(resolve, sec * 1000));
            await _sleep(sleeptime);

            return {
                service: 'SUCCESS',
            };
        },
        async dummyError(sleeptime) {
            const _sleep = (sec: number) => new Promise((resolve) => setTimeout(resolve, sec * 1000));
            await _sleep(sleeptime);

            return {
                service: 'FAILED',
            };
        },
        async onSubmit() {
            console.log('started.');

            const env = this.getEnvString(this.smartmeEnv);
            const scenario = this.getScenarioString(this.scenario);
            console.log(`checking... env:${env}, scenario:${scenario}`);
            if (this.scenario === all) {
                const tasks = [
                    this.executeTest(env, 'refreshAccessTokenThenFetchCard'),
                    this.executeTest(env, 'registerEmployeeAndDeleteIt'),
                    this.executeTest(env, 'createAlligateAdmissionCard'),
                    this.executeTest(env, 'issueCercardThenProofAndVerify'),
                    this.executeTest(env, 'loginCustomerPortalThenShowList'),
                    this.executeTest(env, 'getProofAndVerify'),
                ];
                await Promise.all(tasks);
            } else {
                await this.executeTest(env, scenario);
            }
            console.log(`checked.`);

            this.judgeAvailability();
            console.log('finished.');
        },
        getEndpoint(smartmeEnv: number, scenario: number): string {
            let url: string = '';
            const baseURL = config.azureFunction.scenario[scenario].baseURL[smartmeEnv];
            const orchestrator = config.azureFunction.scenario[scenario].orchestrator;
            const code = config.azureFunction.scenario[scenario].code[smartmeEnv];
            url = baseURL + orchestrator + '?code=' + code + '&forWeb=true';
            console.log(`smartmeEnv:${smartmeEnv}, scenario:${scenario}, baseURL:${baseURL}, orchestrator:${orchestrator}, code:${code}, url:${url}`);

            return url;
        },
        pushBtn(): void {
            this.isProcessing = true;
        },
        finish(): void {
            this.isProcessing = false;
        },

        // 総合判定
        async judgeAvailability(): Promise<void> {
            // 総合判定
            if (
                this.results.refreshAccessTokenThenFetchCard.service === 'SUCCESS' &&
                this.results.registerEmployeeAndDeleteIt.service === 'SUCCESS' &&
                this.results.createAlligateAdmissionCard.service === 'SUCCESS' &&
                this.results.issueCercardThenProofAndVerify.service === 'SUCCESS' &&
                this.results.loginCustomerPortalThenShowList.service === 'SUCCESS' &&
                this.results.getProofAndVerify.service === 'SUCCESS'
            ) {
                this.message.availability = '全ユーザ正常動作中';
                return;
            }
            if (
                this.results.refreshAccessTokenThenFetchCard.service === 'FAILED' &&
                this.results.registerEmployeeAndDeleteIt.service === 'FAILED' &&
                this.results.createAlligateAdmissionCard.service === 'FAILED' &&
                this.results.issueCercardThenProofAndVerify.service === 'FAILED' &&
                this.results.loginCustomerPortalThenShowList.service === 'FAILED' &&
                this.results.getProofAndVerify.service === 'FAILED'
            ) {
                this.message.availability = '全ユーザに異常あり';
                return;
            }

            if (
                this.results.refreshAccessTokenThenFetchCard.service === '未確認' ||
                this.results.registerEmployeeAndDeleteIt.service === '未確認' ||
                this.results.createAlligateAdmissionCard.service === '未確認' ||
                this.results.issueCercardThenProofAndVerify.service === '未確認' ||
                this.results.loginCustomerPortalThenShowList.service === '未確認' ||
                this.results.getProofAndVerify.service === '未確認'
            ) {
                this.message.availability += 'まだ全サービスの正常性の判断ができません。すべてのシナリオを実行してください。';
            }
            if (
                this.results.refreshAccessTokenThenFetchCard.service === 'FAILED' ||
                this.results.registerEmployeeAndDeleteIt.service === 'FAILED' ||
                this.results.createAlligateAdmissionCard.service === 'FAILED' ||
                this.results.issueCercardThenProofAndVerify.service === 'FAILED' ||
                this.results.loginCustomerPortalThenShowList.service === 'FAILED' ||
                this.results.getProofAndVerify.service === 'FAILED'
            ) {
                this.message.availability += '一部ユーザ故障';
                let detail = ' ';
                if (this.results.refreshAccessTokenThenFetchCard.service === 'FAILED' || this.results.registerEmployeeAndDeleteIt.service === 'FAILED') {
                    detail += '三菱電機版故障 ';
                } else if (this.results.refreshAccessTokenThenFetchCard.service === 'SUCCESS' && this.results.registerEmployeeAndDeleteIt.service === 'SUCCESS') {
                    detail += '三菱電機版正常 ';
                }
                if (this.results.createAlligateAdmissionCard.service === 'FAILED') {
                    detail += 'アリゲート版故障 ';
                } else if (this.results.createAlligateAdmissionCard.service === 'SUCCESS') {
                    detail += 'アリゲート版正常 ';
                }
                if (this.results.issueCercardThenProofAndVerify.service === 'FAILED') {
                    detail += '身分証故障 ';
                } else if (this.results.issueCercardThenProofAndVerify.service === 'SUCCESS') {
                    detail += '身分証正常 ';
                }
                if (this.results.loginCustomerPortalThenShowList.service === 'FAILED') {
                    detail += '身分証（カスタマーポータル）故障 ';
                } else if (this.results.loginCustomerPortalThenShowList.service === 'SUCCESS') {
                    detail += '身分証（カスタマーポータル）正常 ';
                }
                if (this.results.getProofAndVerify.service === 'FAILED') {
                    detail += '身分証（APIGW）故障 ';
                } else if (this.results.getProofAndVerify.service === 'SUCCESS') {
                    detail += '身分証（APIGW）正常 ';
                }
                this.message.availability += detail;
            }
        },

        // durable function APIの実行
        async invokeCheckStatus(url: string): Promise<CheckStatusResult> {
            const res: AxiosResponse = await axios.get(url, {});
            return res.data;
        },
        // status APIの実行
        async invokeStatusQueryGetUri(url: string): Promise<StatusQueryGetUriResult> {
            const res: AxiosResponse = await axios.get(url, {});
            return res.data;
        },

        async healthCheckDurableFunction(url: string): Promise<ServiceStatus> {
            const status = new ServiceStatus();
            try {
                const startTime = new Date();
                const checkStatusResult: CheckStatusResult = await this.invokeCheckStatus(url);
                console.log('checkStatusResult: ', checkStatusResult);
                let statusQueryGetUriResult: StatusQueryGetUriResult;
                const _sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms * 1000));
                do {
                    statusQueryGetUriResult = await this.invokeStatusQueryGetUri(checkStatusResult.statusQueryGetUri);
                    console.log('statusQueryGetUriResult: ', statusQueryGetUriResult);
                    if (statusQueryGetUriResult.runtimeStatus === 'Failed' || statusQueryGetUriResult.runtimeStatus === 'Terminated') {
                        throw 'durable function returned error.';
                    }
                    if (statusQueryGetUriResult.runtimeStatus !== 'Completed') {
                        await _sleep(10);
                    }
                    var endTime = new Date();
                    if (endTime.getTime() - startTime.getTime() > timeout_durable_function_msec) {
                        throw 'durable function reach timeout.';
                    }
                } while (statusQueryGetUriResult.runtimeStatus !== 'Completed');

                // サービス（service）確認
                if (Array.isArray(statusQueryGetUriResult.output)) {
                    for (const i in statusQueryGetUriResult.output) {
                        let result = '';
                         if (statusQueryGetUriResult.output[i].result === 'SUCCESS') {
                            result = 'SUCCESS';
                         } else if (statusQueryGetUriResult.output[i].result === 'ERROR') {
                            result = 'FAILED';
                         } else {
                            result = 'FAILED';
                         }
                        status.service = result;
                    }
                } else {
                    // 結果が配列以外（東西リージョンを含まない）の場合
                    if (statusQueryGetUriResult.output.result === 'SUCCESS') {
                        status.service = 'SUCCESS';
                    } else if (statusQueryGetUriResult.output.result === 'ERROR') {
                        status.service = 'FAILED';
                    } else {
                        status.service = 'FAILED';
                    }
                }
            } catch (e) {
                status.service = 'FAILED';
                console.log(JSON.stringify(e));
            }

            console.log(JSON.stringify(status));
            return status;
        },
        setTitle () {
            if (config.toolEnv == "prod") {
                // 商用実行可能な場合は開発・ステージング実行不可
                this.envTitle = '商用';
                this.smartmeEnv = prod;
                this.radioDisabled.prod = false;
                this.radioDisabled.sta = true;
                this.radioDisabled.dev = true;
            } else {
                this.envTitle = '開発・ステージング';
                this.smartmeEnv = dev;
                this.radioDisabled.prod = false;
                this.radioDisabled.sta = false;
                this.radioDisabled.dev = false;
            }
        }
    },
    mounted() {
        this.setTitle();
    }
});
